import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { LocaleCode } from '@/data/types';

export function useLocalized() {
  const { locale } = useI18n();

  const currentLocale = computed(() => locale.value as LocaleCode);

  function pick<T>(map: Record<LocaleCode, T>): T {
    return map[currentLocale.value] ?? map['pt-BR'];
  }

  return { currentLocale, pick };
}
